import styled from 'styled-components';

export const TotalOwnership = styled('section')`
  ${({ theme }) => theme.typography.xSmall}
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const SubHeadingWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;
